<template>
    <div
        class="card overflow-hidden p-2 m-0"
        :class="open ? 'span-grid' : 'interactive-card'"
        @click.stop="$emit('open', event.id)">
        <div
            v-if="open"
            class="m--2">
            <EventEntryDetailsGeneral
                :hide-categories="hideCategories"
                :event="event"
                closeable
                cardless
                @close="$emit('open', null)" />
        </div>
        <div
            v-else
            style="height: 100%;">
            <EventOverviewForTileDisplay
                :event="event"
                :hide-categories="hideCategories" />
        </div>
    </div>
</template>

<script>
import EventOverviewForTileDisplay
    from "@/components/pages/eventIFrame/EventEntry/EventEntryTiles/EventOverviewForTileDisplay";
import EventEntryDetailsGeneral
    from "@/components/pages/eventIFrame/EventEntry/EventEntryTiles/EventEntryDetailsGeneral";

export default {
    name: "EventEntryTile",
    components: {
        EventEntryDetailsGeneral, EventOverviewForTileDisplay
    },
    props: {
        event: {
            type: Object,
            required: true
        },
        open: {
            type: Boolean,
            default: false
        },
        hideCategories: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasImage() {
            return !!this.event?.images?.length
        }
    }
}
</script>

<style lang="scss" scoped>
.span-grid {
    grid-column: 1/-1;
}

.fade-enter-active {
    transition: opacity $iframe-transition-duration $iframe-timing-function;
}

.fade-enter-from {
    opacity: 0 !important;
}

.interactive-card {
    cursor: pointer;
    transition-property: box-shadow, transform;
    transition-duration: $iframe-transition-duration;
    transition-timing-function: cubic-bezier(0.16, 1, 0.29, 0.99);

    &:hover {
        box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.18), 0 1px 2px rgba(0, 0, 0, 0.1);
        transform: translate3d(0, -3px, 0);
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: transparent;
        transition: background-color $iframe-transition-duration ease-out;
    }

    &:hover::before {
        background-color: rgba($gray-800, 0.025);
    }
}
</style>
